<template>
  <div class="notfound">
    <v-container style="max-width: 1000px;">
      <v-row justify="space-between">
        <v-col class="notfound--card"
               align-self="center">
          <h1 class="display-3 font-weight-bold">
            Oops...
          </h1>
          <p class="my-7">
            The page you requested could not be found.
          </p>
          <v-btn
            to="-1"
            small
            dark
            class="subtitle-1 grey darken-1 text-capitalize px-10 py-5"
            @click="goBack()">
            Go Back
          </v-btn>
        </v-col>
        <v-col class="notfound--card">
          <v-img src="../assets/404.png" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
	name: "NotFound",
	methods: {
		goBack: function() {
			this.$router.push({ path: '/' });
		}
	}
};
</script>

<style lang="scss" scoped>
.notfound {
  padding-top: 60px;
  min-height: 600px;

  .notfound--card {
    max-width: 500px;
  }
}
</style>

